import { useCallback } from 'react'
import { ApolloError } from '@apollo/client'

import { SavingsAccountOverviewBannerDebitCardAccountV2Fragment } from '../../../../types/gql-types/SavingsAccountOverviewBannerDebitCardAccountV2Fragment'
import { SavingsAccountOverviewBannerEntityFragment } from '../../../../types/gql-types/SavingsAccountOverviewBannerEntityFragment'
import { useOverviewBannerVisibility } from './hooks/useOverviewBannerVisibility/useOverviewBannerVisibility'
import { SavingsAccountOverviewBanner } from './SavingsAccountOverviewBanner/SavingsAccountOverviewBanner'

interface OverviewBannerProps {
  savingsAccounts: SavingsAccountOverviewBannerDebitCardAccountV2Fragment[]
  interestRate?: SavingsAccountOverviewBannerEntityFragment | null
  isLoading: boolean
  error?: ApolloError
}

export const OverviewBanner = ({
  savingsAccounts,
  interestRate,
  isLoading,
  error,
}: OverviewBannerProps) => {
  const { isBannerHidden, setIsOverviewBannerHidden } =
    useOverviewBannerVisibility()

  const hideOverviewBanner = useCallback(() => {
    setIsOverviewBannerHidden(true)
  }, [setIsOverviewBannerHidden])

  if (isLoading || error || isBannerHidden) {
    return null
  }

  return (
    <SavingsAccountOverviewBanner
      hideOverviewBanner={hideOverviewBanner}
      savingsAccounts={savingsAccounts}
      interestRate={interestRate}
      isLoading={isLoading}
      error={error}
    />
  )
}
